import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import { convertNumbers } from "../../utils/ConvertNumbers";
import moment from "jalali-moment";
import InfoIcon from "@material-ui/icons/Info";
import {
  BLACK,
  BLUE_COLOR,
  DARK_SIDEBAR,
  ERROR_COLOR,
  GREEN_PRIMRY,
  ORANGE_COLOR,
  SILVER_TABLE_COLOR,
  WHITE,
} from "../../utils/const";
import { styled } from "@material-ui/core/styles";
import { useHistory } from "react-router";
import { Split } from "../../utils/Split";
import ReceiptIcon from "@material-ui/icons/Receipt";
import { Link } from "react-router-dom";

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: SILVER_TABLE_COLOR,
  },
  // hide last border
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));

const TableRecord = (props) => {
  const history = useHistory();

  const goToCounterDetails = () => {
    history.push("/admin/counter/" + props.counter.serial);
  };

  const categoryStyle = {
    color: "#fff",
    backgroundColor: "green",
    fontSize: "12px",
    borderRadius: "4px",
    paddingRight: "6px",
    paddingLeft: "6px",
    marginRight: "8px",
  };
  const validStyle = { ...categoryStyle };
  const activeStyle = { ...categoryStyle };
  if (props.counter.category.includes("آب")) {
    categoryStyle.backgroundColor = BLUE_COLOR;
  } else if (props.counter.category.includes("برق")) {
    categoryStyle.backgroundColor = ERROR_COLOR;
  } else {
    categoryStyle.backgroundColor = ORANGE_COLOR;
  }

  if (props.counter.validation) {
    validStyle.backgroundColor = GREEN_PRIMRY;
  } else {
    validStyle.backgroundColor = ERROR_COLOR;
  }
  if (props.counter.activation) {
    activeStyle.backgroundColor = GREEN_PRIMRY;
  } else {
    activeStyle.backgroundColor = ERROR_COLOR;
  }

  const category = (
    <span style={categoryStyle}>{convertNumbers(props.counter.category)}</span>
  );

  const validation = props.counter.validation ? (
    <span style={validStyle}>{"تایید شده"}</span>
  ) : (
    <span style={validStyle}>{"تایید نشده"}</span>
  );
  const activation = props.counter.activation ? (
    <span style={activeStyle}>{"فعال"}</span>
  ) : (
    <span style={activeStyle}>{"غیر فعال"}</span>
  );

  let consumptionDate;
  if (props.counter.consumptionInfo.lastDate) {
    consumptionDate = (
      <>
        <span>
          {/* {convertNumbers(
            moment(props.counter.consumptionInfo.lastDate)
              .locale("fa")
              .format("YYYY/MM/DD")
          )} */}
          0
        </span>
        <br />
        <span>
          {/* {convertNumbers(
            moment(props.counter.consumptionInfo.lastDate)
              .locale("fa")
              .format("HH:mm:ss")
          )} */}
          0
        </span>
      </>
    );
  } else {
    consumptionDate = "ثبت نشده";
  }

  return (
    <StyledTableRow>
      <TableCell component="th" scope="row">
        {convertNumbers(
          props.idx + 1 + props.pageSize * (props.pageNumber - 1)
        )}
      </TableCell>
      <TableCell align="center">{convertNumbers(props.counter.name)}</TableCell>
      <TableCell align="center">
        {convertNumbers(props.counter.serial)}
      </TableCell>
      <TableCell align="center">{category}</TableCell>
      <TableCell align="center">{convertNumbers(props.counter.type)}</TableCell>
      <TableCell align="center">
        {convertNumbers(props.counter.project)}
      </TableCell>
      <TableCell align="center">{validation}</TableCell>
      <TableCell align="center">{activation}</TableCell>
      <TableCell align={"center"}>{consumptionDate}</TableCell>
      <TableCell align={"center"}>
        {convertNumbers(Split(Math.round(props.counter.consumptionInfo.last)))}
      </TableCell>
      <TableCell align={"center"}>
        {convertNumbers(Split(Math.round(props.counter.consumptionInfo.month)))}
      </TableCell>
      <TableCell align={"center"}>
        {convertNumbers(Split(Math.round(props.counter.consumptionInfo.total)))}
      </TableCell>
      <TableCell align={"center"}>
        <Link to={"/admin/counter/" + props.counter.serial + "/bills"}>
          <ReceiptIcon
            style={{
              color: ORANGE_COLOR,
              cursor: "pointer",
              fontSize: "28px",
            }}
          />
        </Link>
      </TableCell>
      <TableCell align="center">
        <InfoIcon
          onClick={goToCounterDetails}
          style={{
            color: BLUE_COLOR,
            cursor: "pointer",
            fontSize: "24px",
          }}
        />
      </TableCell>
    </StyledTableRow>
  );
};

export default TableRecord;
